export const openLinkInNewTab = (link) => {
    window.open(link, '_blank');
  };